export const importReviewAcesColumns: any = [
  {
    title: 'select-all-btn',
    active: false,
    col: 'select-btn',
    cssWidth: '130px',
  },
  {
    title: 'Part no.',
    sortable: true,
    sort: 'desc',
    active: false,
    truncate: true,
    col: 'part_number',
    cssWidth: '15%',
  },
  {
    title: 'Fitments',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'fitments',
    permissions: ['admin', 'fitments'],
    cssWidth: '90px',
  }
];
